import "../style.css";
import imagenFondo from "../images/imagen-fondo-proveedor.png";
import imagenSE from "../images/logoRes.png";
import { useLocation } from "react-router-dom";
import Footer from './Footer';
import { Carousel } from "bootstrap";
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

var dict = { "Presencial" : "https://api.iconify.design/el/group.svg?color=%23c5a263", 
             "Online" : "https://api.iconify.design/mdi/virtual-meeting.svg?color=%23c5a263",
             "Hibrida" : "https://api.iconify.design/ri/exchange-fill.svg?color=%23c5a263"};
    
export const AllyView = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [producto, setProducto] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducto = async () => {
      try {
        const ref = doc(db, 'usersPrincipal', id);
        const docSnap = await getDoc(ref);

        if (docSnap.exists()) {
          setProducto(docSnap.data());
        } else {
          console.error('Producto no encontrado');
          navigate('/'); // o muestra un error específico
        }
      } catch (error) {
        console.error('Error al cargar producto:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducto();
  }, [id, navigate]);

  if (loading) return <div>Cargando producto...</div>;

  const formattedIncludes = producto.includes
    ? producto.includes.split('. ').map((item, index) => (
        <React.Fragment key={index}>
          ● {item}
          <br />
        </React.Fragment>
      ))
    : null;

  /*else if(producto.class === "Cata"){
    return (<div style={{flexGrow:"1"}}>
      <div className="desktop">
        <div className="div">
          <div className="overlap-group">
            <div className="overlap-group">
            <img className="imagen-fondo" alt="Imagen fondo" src={imagenFondo} />
              <div className="text-wrapper">{producto.title}</div>
              <div className="proveedor">
                <div className="rectangle" />
                <img className="imagen" alt="Imagen" src={producto.photo}/>
                <div className="titulo-experiencia"> {producto.extra} </div>
              </div>
            </div>
            <div className="informacion-basica">
              <div className="text-wrapper-3" style={{fontSize: 29, width:"100%", fontWeight: 300, color: "black"}}>
                DESCRIPCIÓN: <hr></hr>
              </div>
              <div className="text-wrapper-2" style={{fontSize: 18, lineHeight: 1.6, textAlign: "justify"}}>{producto.description}</div>
            </div>
            <img className="pepicons-pencil" alt="pepicon" src={imagenSE} />
          </div>
            <div className="texto-experiencia">
              <div className="text-wrapper-3" style={{fontSize: 29, fontWeight: "bolder"}}>
                <br/>DETALLE DEL SERVICIO: <hr></hr></div><br/>
              <div className="text-wrapper-2">
              <div className="text-wrapper-2">
                <img className="iconTxt" alt="Pepicons pencil" src={dict[producto.modality]}/> {producto.modality}</div><br/>
              <div className="text-wrapper-2"></div>
                <img className="iconTxt" alt="Pepicons pencil" src="https://api.iconify.design/pepicons-pencil/people.svg?color=%23c5a263"/>
                Capacidad: {producto.capacity} Personas</div><br/>
              <div className="text-wrapper-2">
                <img className="iconTxt" alt="Octicon person" src="https://api.iconify.design/healthicons/i-schedule-school-date-time.svg?color=%23c5a263" />
                Fecha y Hora: {producto.disponibility}</div><br/>
              <div className="text-wrapper-2">
              <img className="iconTxt" alt="Formkit time" src="https://api.iconify.design/mdi/timer-sand.svg?color=%23c5a263" />
                Duracion: {producto.time}</div><br/>

              <div className="text-wrapper-2">INCLUYE: <br/><br/> {formattedIncludes}</div>
              <div className="text-wrapper-2"><button onClick={()=>{navigate("cotizacion", {state:{producto}})}} className="button">!Cotización Express!</button></div>
            </div>

          <div className="overlap">
            <img className="imagen-SE" alt="Imagen SE" src={producto.photo2} />
            <div className="rectangle-2" />
          </div>
        </div>
      </div>
      <Footer/>
    </div>
    );
  }*/
  if(producto.class === "Regalos Corporati"){
    return (
    <div>
      <div className="desktop">
        <div className="div" style={{height:"1000px"}}>
          <div className="overlap-group">
            <div className="overlap-group">
            <img className="imagen-fondo" alt="Imagen fondo" src={imagenFondo} />
              <div className="text-wrapper">Regalos Corporativos</div>
              <div className="proveedor">
                <div className="rectangle" />
                <img className="imagen" alt="Imagen"  src={producto.photo} />
                <div className="icono-experiencia"><img src="https://firebasestorage.googleapis.com/v0/b/menumarket-b8993.appspot.com/o/anfitrion(1).png?alt=media&token=47eefa98-0ca1-4551-b72b-dddc60d341b7" alt="Telefono" width="45" height="40"/>
                </div>
                <div className="titulo-experiencia"> {producto.title} </div>
              </div>
            </div>
            <div className="informacion-basica">
              <div className="text-wrapper-3" style={{fontSize: 29, width:"100%", fontWeight: 300, color: "black"}}>
                Incluye: <hr></hr>
              </div>
              <div className="frame">
                <div className="text-wrapper-2">{formattedIncludes}</div>
              </div>
            </div>
            <img className="pepicons-pencil" alt="Pepicons pencil" src="https://api.iconify.design/codicon/settings.svg?color=%23c5a263" />
          </div>
          <div className="texto-experiencia">
            <div className="text-wrapper-2">
              <button onClick={()=>{navigate("cotizacion", {state:{producto}})}} className="button">¡Cotización Express!</button>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
    
    );
  }else if(producto.class === "Master Cl"){
    return (
    <div>
      <div className="desktop">
        <div className="div" style={{height:"1400px"}}>
          <div className="overlap-group">
            <div className="overlap-group">
            <img className="imagen-fondo" alt="Imagen fondo" src={imagenFondo} />
              <div className="text-wrapper" >Master Class</div>
              
              <div className="proveedor">
                <div className="rectangle"/>
                <img className="imagen" alt="Imagen"  src={producto.photo} />
                <div className="icono-experiencia"><img src="https://firebasestorage.googleapis.com/v0/b/menumarket-b8993.appspot.com/o/anfitrion(1).png?alt=media&token=47eefa98-0ca1-4551-b72b-dddc60d341b7" alt="Telefono" width="45" height="40"/>
                </div>
                <div className="titulo-experiencia"> {producto.extra} </div>
              </div>
            </div>
            <div className="informacion-basica">
            
              <div className="frame">
                <div className="text-wrapper-2" style={{fontSize: 28, color: "#d5c25d", lineHeight: 1}}>{producto.title}</div>
              </div>
              <div className="frame">
                <div className="text-wrapper-2" style={{fontSize: 18, lineHeight: 2, textAlign: "justify"}}>{producto.description} </div>
              </div>
            </div>
          </div>
          <div className="texto-experiencia">
            <div className="text-wrapper-2">
              <button onClick={()=>{navigate("cotizacion", {state:{producto}})}} className="button">¡Cotización Express!</button>
            </div>
          </div>
          
        </div>
      </div>
      <Footer/>
    </div>
    
    );
  }

  return (
    <div>
      <div className="desktop">
        <div className="div">
          <div className="overlap-group">
            <div className="overlap-group">
            <img className="imagen-fondo" alt="Imagen fondo" src={imagenFondo} />
              <div className="text-wrapper">{producto.title}</div>
              <div className="proveedor">
                <div className="rectangle" />
                <img className="imagen" alt="Imagen" src={producto.photo2} />
                <div className="icono-experiencia"><img src="https://firebasestorage.googleapis.com/v0/b/menumarket-b8993.appspot.com/o/anfitrion(1).png?alt=media&token=47eefa98-0ca1-4551-b72b-dddc60d341b7" alt="Telefono" width="45" height="40"/>
                </div>
                <div className="titulo-experiencia"> {producto.extra} </div>
              </div>
            </div>
            <div className="informacion-basica">
              <div className="text-wrapper-3" style={{fontSize: 29, width:"100%", fontWeight: 300, color: "black"}}>
                Descripción:<hr></hr>
              </div>
              <div className="text-wrapper-2" style={{fontSize: 18, lineHeight: 1.6, textAlign: "justify"}}>{producto.description}</div>
              </div>
              <img className="pepicons-pencil" alt="pepicon" src={imagenSE} />
            </div>
            <div className="texto-experiencia">
              <div className="text-wrapper-3" style={{fontSize: 29}}>
                Detalle: <hr></hr></div><br/>
              <div className="text-wrapper-2">
                <img className="iconTxt" alt="Pepicons pencil" src={dict[producto.modality]}/> {producto.modality}: {producto.city}</div><br/>
              <div className="text-wrapper-2"></div>
              <div className="text-wrapper-2">
                <img className="iconTxt" alt="Pepicons pencil" src="https://api.iconify.design/pepicons-pencil/people.svg?color=%23c5a263"/>
                Capacidad: {producto.capacity} Personas</div><br/>
              <div className="text-wrapper-2">
                <img className="iconTxt" alt="Octicon person" src="https://api.iconify.design/healthicons/i-schedule-school-date-time.svg?color=%23c5a263" />
                Fecha y Hora: {producto.disponibility}</div><br/>
              <div className="text-wrapper-2">
              <img className="iconTxt" alt="Formkit time" src="https://api.iconify.design/mdi/timer-sand.svg?color=%23c5a263" />
                Duración: {producto.time}</div><br/>
              <div className="text-wrapper-2">Incluye: <br/><br/> {formattedIncludes}</div>
              <div className="text-wrapper-2"><button onClick={()=>{navigate("cotizacion", {state:{producto}})}} className="button">¡Cotización Express!</button></div>
            </div>

          <div className="overlap">
            <img className="imagen-SE" alt="Imagen SE" src={producto.photo3} />
            <div className="rectangle-2" />
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};